<template>
    <el-popover
        placement="bottom"
        trigger="manual"
        v-model="visible">
        <div class="input-box" @click="visible=true" slot="reference">
            <el-input
                :placeholder="placeholder"
                prefix-icon="el-icon-date"
                readonly
                style="width:220px"
                v-model="input"
                v-bind="$attrs"
            >
            </el-input>
        </div>
        <div class="quarter" v-clickoutside="handleClickoutside">
            <div class="el-date-picker__header el-date-picker__header--bordered">
                <button 
                    class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
                    @click="handleYear(-1)"
                />
                <span class="el-date-picker__header-label">{{ year }}年</span>
                <button 
                    class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
                    @click="handleYear(1)"
                />
            </div>
            <div class="el-picker-panel__content">
                <button 
                    v-for="item in selectData" :key="item.id" 
                    class="quarter_btn"
                    :class="{ active: isActive(item) }"
                    @click="handleCheckDate(item)"
                >
                    {{item.label}}
                </button>
            </div>
        </div>
    </el-popover>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside';
import { validNum } from '@/utils/validate';
export default {
    name: 'QuarterDate',
    directives: { Clickoutside },
    props: {
        value: {
            type: String
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        min: {
            type: Number
        },
        max: {
            type: Number
        }
    },
    data() {
        return {
            year: new Date().getFullYear(),
            visible: false,
            input: null,
            selectData: Array.from({length: 4}).map((v, i)=> {
                return {
                    value: i+1,
                    label: 'Q'+(i+1)
                }
            })
        }
    },
    methods: {
        handleCheckDate({ value }) {
            const date = `${this.year}-${value}`;
            const showData = `${this.year}-Q${value}`;
            // 如果不判断 相同值的时候就不会走 watch
            if (this.input !== showData) {
                this.input = date;
                this.$emit('input', date)
                this.$emit('change', date)
            }
            this.handleClickoutside()
        },
        handleClickoutside() {
            this.visible = false
        },
        handleYear(num) {
            const { min, max, year } = this;
            if (typeof min ==="number"&& num === -1 && year<=min) {
                return 
            } 
            if (typeof max ==="number"&& num === 1 && year>=max) {
                return 
            }
            this.year +=num
        },
        isActive({value}) {
            if (!this.input) {
                return false
            }else {
                const [ year, q ] = this.input.split('-');
                if (value ===+(q.substring(1)) && +year === this.year) {
                    return true
                }else {
                    return false
                }
            }
        }
    },
    watch: {
        value: {
            handler(newVal) {
                if (!newVal) {
                    this.input = null 
                }else {
                    const [ year, q ] = newVal.split('-');
                    if (!(validNum(year) && this.selectData.map(v=>v.value).includes(+q))) {
                        this.input = null;
                    }else {
                        this.year = +year;
                        this.input = `${year}-Q${q}`
                    }
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.input-box {
    display: inline-block;
}
.quarter {
    width: 292px;
    margin: -12px;
    &_btn {
        display: inline-block;
        border: 0;
        background: 0 0;
        cursor: pointer;
        outline: 0;
        width: 55px;
        margin-right: 10px;
        padding: 6px 0;
        margin-top: 12px;
        border-radius: 3px;
        &:last-child {
            margin-right: 0;
        }
        &:hover {
            color: #409EFF;
        }
        &.active {
            color: #fff;
            background-color: #409EFF;
        }
        
    }
}
</style>